export type HelpSectionId = 'start' | 'projects' | 'sprints' | 'context'

export interface HelpSection {
  id: HelpSectionId
  title: string
  description: string
  markdown: string
}

export const HELP_SECTIONS: HelpSection[] = [
  {
    id: 'start',
    title: 'Быстрый старт',
    description: 'Рабочий цикл, принципы безопасности и реальные команды.',
    markdown: `## Быстрый старт

ai.agents работает как слой управления знаниями поверх взаимозаменяемых движков.

1. Выберите проект и спринт.
2. Дайте агенту задачу в Telegram или web-канале.
3. В конце смыслового блока выполните checkpoint.
4. Агент сохранит выводы в vault: roadmap, docs, chats или context.

Главное правило: агент может быть заменён, а знание остаётся в markdown и git.`,
  },
  {
    id: 'projects',
    title: 'Проекты',
    description: 'Vault, проектные узлы, подпроекты и граница repo/.',
    markdown: `## Проекты

Проект — папка верхнего уровня с обязательным \`context.md\`, документацией,
спринтами, проектными скилами и репозиториями.

- \`context.md\` хранит карту проекта, ссылки и решения.
- \`docs/\` хранит постоянную архитектуру и продуктовые документы.
- \`sprints/\` хранит текущую работу: roadmap, chats и specs.
- \`repo/\` не входит в автосборку знания.

Подпроектом становится любая вложенная папка с собственным \`context.md\`.

Owner-web подтверждение дополнительных прав является live-flow для web-сессий:
\`/api/sessions\` отдаёт pending permission, а allow/deny применяется через
\`POST /api/sessions/:id/permission\` только к текущему web-run.`,
  },
  {
    id: 'sprints',
    title: 'Спринты',
    description: 'Roadmap, статусы задач, проверка закрытия и журнал.',
    markdown: `## Спринты

Спринт — минимальная единица обещания и проверки. Каждый спринт содержит один
\`roadmap.md\` и журнал с конспектами.

Статусы задач:

- \`[ ]\` todo с критерием приёмки;
- \`[~]\` in progress с исполнителем;
- \`[x]\` done;
- \`[!]\` blocked с причиной.

Спринт закрывается только после выполнения проверки закрытия или явной записи
исключения в журнале.`,
  },
  {
    id: 'context',
    title: 'Контекст',
    description: 'Алгебра окна, бюджеты, checkpoint и новая сессия.',
    markdown: `## Контекст

Контекст собирается слоями:

1. надпроекты;
2. проект и docs;
3. текущий спринт;
4. системные и проектные скилы;
5. текущая переписка.

Для \`misc\` вместо sprint context используется context.subproject. Сырые логи,
\`repo/\`, \`chats/\`, \`specs/\` и \`docs/reference/\` не входят в автосборку.

Бюджеты long-context runtime:

- \`context.md\` и context-карты зон — 4–6 тыс. слов;
- каждый файл \`docs/*.md\` — 6–10 тыс. слов;
- \`sprint.context\` — до 20–30% окна;
- \`context.session\` на старте — до 60% окна.

Базовое окно транспорта — 1M токенов; при необходимости его можно сузить через
\`CONTEXT_WINDOW_TOKENS\`.

При росте окна агент должен предложить checkpoint, а не молча вытеснять важные
проектные документы.`,
  },
]

export function getHelpSection(id: HelpSectionId): HelpSection {
  const fallback = HELP_SECTIONS[0]
  if (!fallback) {
    throw new Error('HELP_SECTIONS fixture must contain at least one section')
  }
  return HELP_SECTIONS.find((section) => section.id === id) ?? fallback
}
